import { FileStoreAspectRatio, FileStoreStatus } from '../menu/menu.types';

export enum Mimetypes {
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
}
export enum FileTypes {
  XLSX = 'xlsx',
  CSV = 'csv',
}
export enum FileImageType {
  Jpg = 'jpg',
  Png = 'png',
  PDF = 'application/pdf',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  TEXT_CSV = 'text/csv',
  // You can add more file extensions here as needed
}
export interface fileImage {
  id?: string;
  name: string;
  size: number;
  fileFor: string;
  fileUrl: string;
  type: FileImageType;
  restaurantId: number;
  businessId: number;
  aspectRatio: FileStoreAspectRatio;
  status: FileStoreStatus;
  createdAt?: Date;
  updatedAt?: Date;
}
export interface FileDataResponse {
  id: string;
  name: string;
  size: string;
  fileFor: string;
  fileUrl: string;
  type: string;
  restaurantId: number;
  businessId: number;
}
export interface fileResponse {
  data: FileDataResponse;
  message: string;
  error?: string | null;
  success?: boolean | null;
}

export interface Meta {
  created?: number;
  notCreated?: number;
}

export enum FILE_FORMAT {
  XLSX = 'xlsx',
  CSV = 'csv',
  XLS = 'xls',
  DOCX = 'docx',
  PDF = 'pdf',
  JPEG = 'jpeg',
  PNG = 'png',
}

export const FILE_TYPES: Record<FILE_FORMAT, string> = {
  [FILE_FORMAT.XLSX]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  [FILE_FORMAT.CSV]: 'application/csv',
  [FILE_FORMAT.XLS]: 'application/vnd.ms-excel',
  [FILE_FORMAT.DOCX]: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  [FILE_FORMAT.PDF]: 'application/pdf',
  [FILE_FORMAT.JPEG]: 'image/jpeg',
  [FILE_FORMAT.PNG]: 'image/png',
};
